import { FC } from 'react';
import { AlertPrevention } from './AlertPrevention/AlertPrevention';

export const AlertPreventionPage: FC = () => {
  return <AlertPrevention />;
};
